import { ChangeDetectionStrategy, Component, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngxs/store';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { Subject, fromEvent, merge } from 'rxjs';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { HotkeyService } from './services/hotkey/hotkey.service';
import { ConnectSignalR } from './store/server-communication/server-communication.actions';
import { SettingsState } from './store/settings/settings.state';

@Component({
   selector: 'samweb-root',
   templateUrl: './app.component.html',
   styleUrls: ['./app.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
   private destroy$ = new Subject();

   @ViewChild(ToastContainerDirective, { static: true }) toastContainer: ToastContainerDirective;

   constructor(private samStore: Store, private toastrService: ToastrService, private hotkeyService: HotkeyService) {
      this.samStore
         .select(SettingsState.appliedTheme)
         .pipe(takeUntil(this.destroy$))
         .subscribe((theme) => {
            this.themeClass = theme.className;
         });

      merge(fromEvent<KeyboardEvent>(document, 'keyup'), fromEvent<KeyboardEvent>(document, 'keydown'))
         .pipe(
            distinctUntilChanged((a, b) => a.code === b.code && a.type === b.type),
            // PrintScreen and Meta key are only triggered on keyup
            filter((e) => e.type === 'keydown' || e.code === 'PrintScreen' || e.metaKey),
            takeUntil(this.destroy$)
         )
         .subscribe((e) => {
            const shortcutHandled = this.hotkeyService.handleKeyEvent(e);
            if (shortcutHandled) {
               e.stopPropagation();
               e.preventDefault();
            }
         });
   }

   @HostBinding('class') themeClass;

   ngOnInit(): void {
      this.toastrService.overlayContainer = this.toastContainer;
      this.samStore.dispatch(new ConnectSignalR());
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
